module.exports = "\r\n\r\n.panel {\r\n  border: 1px solid #d1d6e6;\r\n}\r\nlabel.fancy-checkbox.custom-bgcolor-green {\r\n  margin-top: 5px !important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/category-components/parent-category/edit-parent-category/edit-parent-category.component.css
// module id = ./src/app/category-components/parent-category/edit-parent-category/edit-parent-category.component.css
// module chunks = main